import React from "react";
import { Toaster } from "@/components/ui/sonner";
import { Seo } from "@/components/Seo";
import { ContactProvider } from "@/contexts/ContactContext";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { About } from "@/components/landing/About";
import { Services } from "@/components/landing/Services";
import { Showcase } from "@/components/landing/Showcase";
import { Technology } from "@/components/landing/Technology";
import { HowWeWork } from "@/components/landing/HowWeWork";
import { FinalCTA, Footer } from "@/components/landing/FinalCTA";

const LandingPage = () => {
  return (
    <ContactProvider>
      <Seo />
      <main data-testid="landing-page" className="bg-black text-white">
        <Navbar />
        <Hero />
        <Marquee />
        <About />
        <Services />
        <Showcase />
        <Technology />
        <HowWeWork />
        <FinalCTA />
        <Footer />
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            classNames: {
              toast:
                "bg-[#0a0a0c] border border-fuchsia-500/30 text-white",
              description: "text-white/60",
            },
          }}
        />
      </main>
    </ContactProvider>
  );
};

export default LandingPage;
